import React from "react";
import { ChevronDown, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { BusinessReportOutcomeShareModal } from "../modals/shareModal";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails;
}

export const BusinessReportOutcomeHeaderMenu: React.FC<Props> = ({ businessReportOutcome }) => {
  const [isShareOpen, setIsShareOpen] = React.useState(false);

  return (
    <>
      {isShareOpen && (
        <BusinessReportOutcomeShareModal
          setIsOpen={setIsShareOpen}
          isOpen={isShareOpen}
          businessReportOutcome={businessReportOutcome}
        />
      )}

      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="empty" className="h-8 w-8 p-0">
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => setIsShareOpen(true)} className="cursor-pointer">
            <Share className="mr-2 h-4 w-4" />
            Share
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
